export default "__VITE_ASSET__Ca5YC00N__"